import { LngLat } from '@breezeventures/ui-kit/map';

import { StoreAddressFormValues } from './schemas/store-address-schema';
import {
  OfflineStoreFormValues,
  OnlineStoreFormValues,
} from './schemas/store-details-schema';
import { StorePhotosFormValues } from './schemas/store-photos-schema';

export const offlineStoreDataGuard = (
  store: StoreData
): store is OfflineStoreData => store.details.type === 'OFFLINE';

export const onlineStoreDataGuard = (
  store: StoreData
): store is OnlineStoreData => store.details.type === 'ONLINE';

export type OnlineStoreData = {
  details: OnlineStoreFormValues;
};

export type OfflineStoreData = {
  details: OfflineStoreFormValues;
  address: StoreAddressFormValues;
  coordinates: LngLat | null;
  photos: StorePhotosFormValues;
};

export type StoreData = OnlineStoreData | OfflineStoreData;
